import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';

import {useSettings} from './useSettings';

const defaultDatesSettings = {
    dayData: {},
    startDayDataId: '',
    endDayDataId: '',
    selectedDayDataId: '',
    isOpen: false,
    isSelecting: undef,
    readOnly: false,
    showContinueButton: true
};

function useDatesSettings(props) {
    const {
        datesSettings: propsDatesSettings
    } = props;

    const {
        initialSettings: initialDatesSettings,
        settings: datesSettings,
        changeSettings: changeDatesSettings
    } = useSettings(defaultDatesSettings, propsDatesSettings);

    const result = {
        initialDatesSettings,
        datesSettings,
        changeDatesSettings
    };

    useDebugValue(result);

    return result;
}

export {useDatesSettings};
